import type { IconData } from '@stacksjs/iconify-core'

export const basicUiUser2: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8 8a4 4 0 1 0 0-8a4 4 0 0 0 0 8m0 0H0a8 8 0 1 0 16 0z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default basicUiUser2
